import React, { Component } from 'react';
import { Table, Row, Button, message, Select } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import { columnsColumn, listName } from './data';
import TableText from "../../table/TableText";
import FileSaver from "file-saver";

const totalIndex = [];
const Option = Select.Option;
@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        const month = moment().format('M');
        this.state = {
            date: month < 3 ? moment().format('YYYY') : moment().add(1, 'y').format('YYYY'),
            loadingSave: false,
            print: false,
            data: [],
            loading: true,
            columnData: [],
            dateData: [],
        }
    }

    componentDidMount() {
        let date = Number(this.state.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
        this.getDateData(this.state.date);
    }


    onChange = (name, value, i) => {

    }

    getDateData = (date) => {
        fetch(`/bp/headquarters/8?year=${moment(date).format('YYYY')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            const data = x.data || [];

            let _data = data.reduce((a, b, i) => {
                const year = moment(date).format('Y');
                let names = ['ava', 'rn', 'occ', 'arr', 'revpar', 'rev'];
                let years = [`Actual  ${year - 2}`, `Budget  ${year - 1}`, `Act+ Fcst ${year - 1}`, `Budget ${year}`];

                for (let _i = 0; _i < years.length; _i++) {
                    a.push({
                        name: b.name,
                        typename: years[_i],
                        ...names.reduce((x, y, j) => {
                            x[y] = b[listName[j][_i]] || 0
                            return x
                        }, {})
                    })
                }
                return a
            }, []);
            this.setState({ data, loading: false, columnData: _data });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let data = this.state.data.map((x, i) => ({ ...x, year, }));

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/bpAdd_8_0_new', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadExcel = (id) => {
        const tableName = `Budget Summary`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById(id).innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { print, data, date, loading, columnData } = this.state;
        const width = document.body.offsetWidth - 4800 > 500 ? document.body.offsetWidth - 4800 : 500;

        return (
            <div>
                <div className="table7_1_1 tableHeight">
                    <Row className="title" style={{ width: print ? 5350 : 'auto' }}>
                        <Row>BP8.2.1 Budget By Market Segment汇总表</Row>
                        <Row className="table-month">
                            <Select
                                placeholder="请选择年份"
                                style={{ width: 120, marginTop: 20 }}
                                value={date}
                                onChange={(str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            >
                                {this.state.dateData.map((x, i) => {
                                    return (
                                        <Option value={x} key={x}>{x}年</Option>
                                    )
                                })}
                            </Select>
                        </Row>
                        <Table
                            columns={columnsColumn.map(x => {
                                return {
                                    title: x.name,
                                    key: x.key,
                                    dataIndex: x.key,
                                    width: x.key == 'name' ? 300 : 100,
                                    render: (text = 0, record, index) => {
                                        const props = { text, index, type: x.type, name: x.key, };
                                        if (x.key == 'name') {
                                            return {
                                                props: {
                                                    rowSpan: index % 4 == 0 ? 4 : 0
                                                },
                                                children: <TableText data={props} />
                                            }
                                        }
                                        return <TableText data={props} />
                                    }
                                }
                            })}
                            dataSource={columnData}
                            size="middle"
                            id="table4_1_6"
                            bordered
                            loading={loading}
                            pagination={false}
                            rowClassName="protruding"
                            className="content"
                            scroll={print ? {} : { y: 500 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.downloadExcel("table4_1_6");
                                });
                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                    </Row>
                </div>
            </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/BPBudgetSummary/BP8_2_1.js